module.exports = __webpack_public_path__ + "static/media/calender.1a3265e4.svg";